import { render, staticRenderFns } from "./SupplierRawMaterialProductTreatments.vue?vue&type=template&id=4e4b59cc&scoped=true"
import script from "./SupplierRawMaterialProductTreatments.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialProductTreatments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b59cc",
  null
  
)

export default component.exports